import React, { useState } from 'react';
import StudentForm from './StudentForm';
import TutorForm from './TutorForm';
import AdminForm from './AdminForm';
import TutorCards from './TutorCards';
import StudentCards from './StudentCards';
import AdminTab from './AdminTab';
import AdministratorPage from './AdministratorPage';
import RootPage from './RootPage';

const SimpleTabs = () => {
  const [activeTab, setActiveTab] = useState('administrator');

  const tabs = [
     { id: 'administrator', label: 'ADMINISTRATOR' },
    { id: 'tutor', label: 'TUTOR' },
    { id: 'student', label: 'STUDENT' },
   
    //  { id: 'home', label: 'HOME' }
  ];

  const tabContent = {
     administrator: (
      <div className="p-6">
        <AdministratorPage/>
      </div>
    ),
    tutor: (
        <div className="p-6">
          <TutorCards/>
        </div>
    ),
    student: (
      <div className="p-6">
        <StudentCards />
      </div>
    ),
   
    home: (
      <div className="p-6">
        <RootPage/>
      </div>
    )
  };

  return (
    <div className="min-h-screen bg-base-200 p-4">
      <div className="max-w-full mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary mb-2">User Registration</h1>
          {/* <p className="text-lg text-gray-600">Select your role to continue</p> */}
        </div>

        {/* Tabs */}
        <div className="tabs tabs-boxed justify-center mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab tab-lg ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
             <span className='bg-secondary text-white py-1 px-2 rounded'>{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="bg-base-100 rounded-box shadow-xl">
          {tabContent[activeTab]}
        </div>
      </div>
    </div>
  );
};

export default SimpleTabs;